export default "__VITE_ASSET__Bn1OLHN6__"